export const aciParkingAdditionalCharges = {
    iconName: 'parking-additional-charges',
    svgDef: {
        attr: { fill: 'none', viewBox: '0 0 24 25' },
        path: [
            {
                attr: {
                    'fill-rule': 'evenodd',
                    'clip-rule': 'evenodd',
                    d: 'M12.113 8.731a4.4 4.4 0 118.799 0 4.4 4.4 0 01-8.799 0zm4.4-3.399a3.4 3.4 0 100 6.799 3.4 3.4 0 000-6.799z',
                    fill: 'currentColor',
                },
            },
            {
                attr: {
                    'fill-rule': 'evenodd',
                    'clip-rule': 'evenodd',
                    d: 'M15.037 6.781a.5.5 0 01.5-.5h.975a1.475 1.475 0 010 2.95h-.475v1.45a.5.5 0 11-1 0v-3.9zm1 1.45h.475a.475.475 0 100-.95h-.475v.95zM15.6 15.758c.236-.195.532-.301.838-.301h1.236a.5.5 0 010 1h-1.236a.317.317 0 00-.278.467.316.316 0 00.16.142l1.255.502a1.316 1.316 0 01-.49 2.537H15.85a.5.5 0 110-1h1.234a.316.316 0 00.119-.609l-1.255-.501a1.316 1.316 0 01-.348-2.238z',
                    fill: 'currentColor',
                },
            },
            {
                attr: {
                    'fill-rule': 'evenodd',
                    'clip-rule': 'evenodd',
                    d: 'M16.766 15a.5.5 0 01.5.5v.456a.5.5 0 11-1 0V15.5a.5.5 0 01.5-.5zM16.766 19.105a.5.5 0 01.5.5v.456a.5.5 0 11-1 0v-.456a.5.5 0 01.5-.5z',
                    fill: 'currentColor',
                },
            },
            {
                attr: {
                    'fill-rule': 'evenodd',
                    'clip-rule': 'evenodd',
                    d: 'M13.832 14.848a4.148 4.148 0 115.866 5.866 4.148 4.148 0 01-5.866-5.866zm2.933-.215a3.147 3.147 0 100 6.295 3.147 3.147 0 000-6.295zM7.846 8.938A2.094 2.094 0 005.89 10.28l-1.233 2.748a.5.5 0 10.912.41l1.24-2.762a1.094 1.094 0 011.037-.739h3.4a.5.5 0 000-1h-3.4zM4.086 17.297a.5.5 0 00-.5.5V19a1.563 1.563 0 103.125 0v-1.063a.5.5 0 00-1 0v1.063a.562.562 0 11-1.125 0v-1.204a.5.5 0 00-.5-.5z',
                    fill: 'currentColor',
                },
            },
            {
                attr: {
                    'fill-rule': 'evenodd',
                    'clip-rule': 'evenodd',
                    d: 'M13.912 13.156a.5.5 0 00-.5-.5H5.681a2.625 2.625 0 00-2.625 2.625v1.594a1.563 1.563 0 001.562 1.563h7.068a.5.5 0 100-1H4.618a.563.563 0 01-.562-.563v-1.594a1.625 1.625 0 011.625-1.625h7.731a.5.5 0 00.5-.5z',
                    fill: 'currentColor',
                },
            },
            {
                attr: {
                    'fill-rule': 'evenodd',
                    'clip-rule': 'evenodd',
                    d: 'M5.945 15.781a.234.234 0 110-.469v-.53a.766.766 0 010 1.53v-.53z',
                    fill: 'currentColor',
                },
            },
            {
                attr: {
                    'fill-rule': 'evenodd',
                    'clip-rule': 'evenodd',
                    d: 'M5.945 14.781a.766.766 0 000 1.531v-.53a.234.234 0 100-.47v-.53z',
                    fill: 'currentColor',
                },
            },
        ],
    },
};
